import { type } from 'arktype';
import { dayKeySchema } from './day-key.model';
import { utcInstantSchema } from './utc-instant.model';
import type { BookingEntryMethod } from './my-week.model';

export const createManualBookingSchema = type({
  personId: 'string',
  bookingDate: dayKeySchema,
  startTime: utcInstantSchema,
  endTime: utcInstantSchema,
  'breakMinutes?': 'number.integer >= 0',
  'notes?': 'string | null',
  'homeOffice?': 'boolean',
  'note?': 'string | null',
});

export type CreateManualBooking = typeof createManualBookingSchema.t;

export const updateManualBookingSchema = type({
  'bookingDate?': dayKeySchema,
  'startTime?': utcInstantSchema,
  'endTime?': utcInstantSchema,
  'breakMinutes?': 'number.integer >= 0',
  'notes?': 'string | null',
  'homeOffice?': 'boolean',
  'note?': 'string | null',
});

export type UpdateManualBooking = typeof updateManualBookingSchema.t;

export interface ManualBooking {
  id: string;
  personId: string;
  bookingDate: string;
  startTime: string;
  endTime: string;
  breakMinutes: number;
  notes: string | null;
  homeOffice: boolean;
  note: string | null;
  entryMethod: BookingEntryMethod | null;
  status: 'confirmed' | 'voided';
  bookingRecordId: string | null;
  /** Shift booking id this entry was captured from; null for free manual entries. */
  capturedFromShiftUnitId: string | null;
  createdAt: string;
  updatedAt: string;
}
